import { render } from "./Sets.vue?vue&type=template&id=1798ae76"
import script from "./Sets.vue?vue&type=script&lang=js"
export * from "./Sets.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__